// ############  var  ############
var winWidth    = $(window).width();
var winHeight   = $(window).height();
var scrollTop   = $(window).scrollTop();
var breakpoint  = {'pc': 1200, 'tb': 992, 'sp': 768};
var headerTag   = $('.l-header');



$(document).ready(function() {

  // slideout
  var slideout = new Slideout({
    'panel': document.getElementById('js-so_panel'),
    'menu': document.getElementById('js-so_menu'),
    'duration': 10,
    'openclass': 'slideout-open',
  });
  var nodeList = document.querySelectorAll('#js-so_toggle, #js-so_panel');
  var node = Array.prototype.slice.call(nodeList,0);
  node.forEach(function(elem, index){
    elem.addEventListener('click', function() {
      slideout.toggle();
    });
  });
  var nodeListClose = document.querySelectorAll('#js-so-menu .js-scroll');
  var nodeClose = Array.prototype.slice.call(nodeListClose,0);
  nodeClose.forEach(function(elem, index){
    elem.addEventListener('click', function() {
      slideout.close();
    });
  });

  if ( document.getElementById("js-works_panel") != null ) {
    var slideoutWorks = new Slideout({
      'panel': document.getElementById('js-works_panel'),
      'menu': document.getElementById('js-works_conts'),
      'duration': 10,
      'openclass': 'work-open',
    });
    var nodeWork = document.getElementById('js-works_toggle');
    nodeWork.addEventListener('click', function() {
      if ( nodeWork.classList.contains("is-act") ) {
        nodeWork.classList.remove("is-act")
        slideoutWorks.close();
      } else {
        nodeWork.classList.add("is-act")
        slideoutWorks.open();
      }
    });
  }


  // accordion
  $('.js-accordion').on('click', function(){
    if ( $(this).hasClass('is-act') ) {
      $(this).removeClass('is-act').next().stop().slideUp('fast');
    } else {
      $(this).addClass('is-act').next().stop().slideDown('fast');
    }
  });

  // more btn
  $('.js-morebtn').on('click', function(){
    if ( $(this).hasClass('is-act') ) {
      $(this).removeClass('is-act').closest('.-more').next().stop().slideUp('fast');
    } else {
      $(this).addClass('is-act').closest('.-more').next().stop().slideDown('fast');
    }
    return false;
  });


  // mute btn
  $('.js-mute').on('click', function(){
    let video = $('.js-video');
    if ( $(this).hasClass('is-muted') ) {
      $(this).removeClass('is-muted');
      video.each( function(index, element){
        $(this).prop('muted', false);
      });
    } else {
      $(this).addClass('is-muted');
      video.each( function(index, element){
        $(this).prop('muted', true);
      });
    }
  });


  // content nav
  $('.js-nav_hd > li > a').on('click', function(){
    var clickHref = $(this).attr('href');
    var navWrap   = $(this).closest('.js-nav_hd');
    var clickObj  = navWrap.find('a');
    var mainWrap  = navWrap.parent().next();

    clickObj.removeClass('is-act');
    $(this).addClass('is-act');

    if ( clickHref == '#left' ) {
      mainWrap.removeClass('is-visible_right');
    } else {
      mainWrap.addClass('is-visible_right');
    }

    return false;
  });


  // URL copy
  $('.js-url').on('click', function(){
    var $alert_obj = $(this).next();
    $('body').append('<textarea id="js-url_textarea" style="position:aboslute; z-index: -1; opacity: 0;">'+location.href+'</textarea>');
    $('#js-url_textarea').select();
    document.execCommand('copy');
    $('#js-url_textarea').remove();
    $alert_obj.fadeIn( 400, function(){
      setTimeout(function(){
        $alert_obj.fadeOut('fast');
      }, 500);
    });

    return false;
  });



  // table_wrap
  if ( document.getElementById('js-editor') != null ) {
    $('#js-editor table').each(function() {
      $(this).wrap('<div class="c-tblwrap"></div>');
    });
  }


  // lightbox
  $('#lightbox .lb-nav').on('click', function(){
    $('#lightboxOverlay').click();
    return false;
  });


  // form
  if ( document.getElementById('js-contact') != null ) {
    let storeVal = $('input[name="contact_store"]:checked').val();

    $('.js-unchecked').on('click', function(){
      $(this).prev('input').prop('checked', false);
    });

    $('input[name="contact_request"]').on('change', function(){
      let checkVal = $('input[name="contact_request"]:checked').val();
      if ( checkVal == 'SOLSO FARM' ) {
        $('.-view_park, .-view_home, .-view_solso, .-view_type').css('display', 'none').find('input').prop('checked', false);
        $('.-view_farm, .-view_store').css('display', 'block');
      } else if( checkVal == 'SOLSO PARK' ) {
        $('.-view_farm, .-view_home, .-view_solso, .-view_type').css('display', 'none').find('input').prop('checked', false);
        $('.-view_park, .-view_store').css('display', 'block');
      } else if( checkVal == 'SOLSO HOME' ) {
        $('.-view_farm, .-view_park, .-view_solso, .-view_type').css('display', 'none').find('input').prop('checked', false);
        $('.-view_home, .-view_store').css('display', 'block');
      } else if( checkVal == '特になし Not applicable' ) {
        $('.-view_farm, .-view_park, .-view_home, .-view_store, .-view_type').css('display', 'none').find('input').prop('checked', false);
        $('.-view_solso').css('display', 'block');
      } else {
        $('.-view_farm, .-view_park, .-view_home, .-view_store, .-view_solso, .-view_type').css('display', 'none').find('input').prop('checked', false);
      }

    }).change();

    $('input[name="contact_type"]').on('change', function(){
      let checkVal = $('input[name="contact_type"]:checked').val();
      if ( checkVal == 'SOLSO HOMEに関して About SOLSO HOME' || checkVal == '店舗に関して About store' ) {
        $('.-view_type').css('display', 'block');
      } else {
        $('.-view_type').css('display', 'none');
      }
      $('input[name="contact_store"]').prop('checked', false);
    }).change();

    $('input[name="contact_store"]').val([storeVal]);


    // referer
    let ref = document.referrer;
    let contact_request = $('input[name="contact_request"]');
    let contact_from    = $('input[name="contact_from"]');

    if ( ref.indexOf( 'solsofarm.com' ) !== -1 ) {
      contact_request.val(['SOLSO FARM']);
      contact_from.val('SOLSO FARMからの流入');
    } else if( ref.indexOf( 'solsohome.com' ) !== -1 ) {
      contact_request.val(['SOLSO HOME']);
      contact_from.val('SOLSO HOMEからの流入');
    } else if( ref.indexOf( 'solsopark.com' ) !== -1 ) {
      contact_request.val(['SOLSO PARK']);
      contact_from.val('SOLSO PARKからの流入');
    }

    // console.log(ref);

  }


  if ( document.getElementById('js-confirm') != null ) {
    $.when(
      $('.radio_blank').remove(),
      $('.c-btn_back').html('<svg viewBox="0 0 48 32"><use xlink:href="#icon-arrow"></use></svg>Back'),
    ).done(function() {
      let storeVal = $('input[name="contact_store"]').val();
      if ( storeVal == '' ) {
        $('.-view_type').css('display', 'none');
      }
    });
  }


  // // tab
  // $('.js-tabbtn').each(function(){
  //   $('> li > a', this).on('click', function(){
  //     var tabHref   = $(this).attr('href');
  //     var clickWrap = $(this).closest('.js-tabbtn');
  //     var tabObj    = clickWrap.find('a');
  //     var contsObj  = clickWrap.next('.js-tabconts').children('div');

  //     tabObj.removeClass('is-act');
  //     $(this).addClass('is-act');

  //     contsObj.hide();
  //     $(tabHref).fadeIn();

  //     return false;
  //   }).eq(0).click();
  // });



  // // slick
  // $('.js-sld_key').slick({
  //   fade: true,
  //   autoplay: true,
  //   autoplaySpeed: 5000,
  //   speed: 1200,
  //   cssEase: 'linear',
  //   arrows: false,
  //   dots: true,
  //   pauseOnFocus: false,
  //   pauseOnHover: false,
  // });
  // $('.js-sld_pickup').slick({
  //   autoplay: true,
  //   autoplaySpeed: 5000,
  //   speed: 1200,
  //   slidesToShow: 3,
  //   arrows: true,
  //   prevArrow: '<button class="slick-prev-cus slick-arrow" aria-label="Previous" type="button"></button>',
  //   nextArrow: '<button class="slick-next-cus slick-arrow" aria-label="Next" type="button"></button>',
  //   dots: false,
  //   pauseOnFocus: false,
  //   pauseOnHover: false,
  //   responsive:[
  //     {
  //       breakpoint: 992,
  //       settings:{
  //         slidesToShow: 2,
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings:{
  //         slidesToShow: 2,
  //         arrows: false,
  //         dots: true,
  //       }
  //     },
  //   ]
  // });


});


// $(window).on('load', function() {
//   $('.ios .js-video').each( function(index, element){
//     $(this).play();
//   });
// });